import clsx from 'clsx';
import ImageWithFallback from 'components/ImageWithFallback';
import { observer } from 'mobx-react-lite';
import styles from './what-can-we-win.module.css';

export type TSharedWinPrize = {
  win: string;
  friendWin: string;
  winPrefix?: string;
  variedImage?: boolean;
  image: string;
};

interface WhatCanWeWinCardProps {
  sharedWinPrize: TSharedWinPrize;
}

const WhatCanWeWinCard = observer(
  ({ sharedWinPrize }: WhatCanWeWinCardProps) => {
    return (
      <div className={styles.whatCanWeWinCard}>
        <div
          className={clsx(
            styles.winImage,
            sharedWinPrize.variedImage && styles.variedImage,
          )}
        >
          <ImageWithFallback
            src={sharedWinPrize.image}
            width={'100%'}
            height={'100%'}
          />
        </div>
        <div className={styles.winTextWrapper}>
          <div
            className={clsx(
              styles.winTitleAbove,
              'aboutUsTypographyHeaderMedium',
            )}
          >
            You’ll win {sharedWinPrize.winPrefix ?? 'a'}
          </div>
          <div
            className={clsx(styles.winTitle, 'aboutUsTypographyHeaderLarge')}
          >
            {sharedWinPrize.win}
          </div>
          <div className={styles.winSubtitle}>
            When your friends match {sharedWinPrize.friendWin}
          </div>
        </div>
      </div>
    );
  },
);

export default WhatCanWeWinCard;
